import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-gallery-title',
  templateUrl: './gallery-title.component.html',
  styleUrls: ['./gallery-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryTitleComponent {
  @Input({ required: true })
  keyword!: string;

  get title(): string {
    return `${this.keyword} videos`.replace(/\s{2,}/g, ' ');
  }

  get description(): string {
    return `Explore and download high-resolution and RAW ${this.keyword.toLowerCase()} videos for your next project.`.replace(
      /\s{2,}/g,
      ' ',
    );
  }
}
